import React, { useContext } from 'react';
import SingleSlide from './singleSlide';
import Carousel from '../../components/carousel';

import useTeamStyles from './styles';
import PageContext from '../../contexts/pageContext';

function TeamCard({ sectionData, sectionIndex }) {
  const {
    isMobile,
    layout: { containerWidth }
  } = useContext(PageContext);

  const [teamData] = sectionData.components;
  const cardsCount = teamData?.teamCarousel?.components?.length;
  const slidesToShow = isMobile ? 1 : 4;

  const classes = useTeamStyles({
    containerWidth,
    cardsCount,
    slidesToShow,
    isMobile
  });

  const settings = {
    className: classes.sliderContainer,
    slidesToShow,
    slidesToScroll: 1,
    infinite: true,
    centerPadding: isMobile ? '40px 0 0' : '8px 0 0 ',
    centerMode: true
  };

  const getCarouselContent = (fullWidth = false) =>
    teamData.teamCarousel.components.map((data, idx) => {
      return (
        <SingleSlide
          key={idx}
          data={data}
          sectionIndex={sectionIndex}
          fullWidth={fullWidth}
          isMobile={isMobile}
        />
      );
    });

  return (
    <section className={classes.teamSuperContainer}>
      <div className={classes.sectionContainer}>
        <div className={classes.teamHeading}>
          <span
            ref={teamData?.teamHeading?.refSetter}
            dangerouslySetInnerHTML={{
              __html: teamData.teamHeading.metadata.value
            }}
          />
        </div>
        <h2 className={classes.teamTitle}>
          <span
            ref={teamData?.teamTitle?.refSetter}
            dangerouslySetInnerHTML={{
              __html: teamData.teamTitle.metadata.value
            }}
          />
        </h2>

        {cardsCount > slidesToShow ? (
          <Carousel hideArrow={isMobile} settings={settings}>
            {getCarouselContent(true)}
          </Carousel>
        ) : (
          <div className={classes.contentRow}> {getCarouselContent()}</div>
        )}
      </div>
    </section>
  );
}

export default TeamCard;
